module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-7-m2.0990ca80.jpg";